import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

// Master routing
const AlumniProfile = Loadable(
  lazy(() => import("views/alumniRegistration/alumniProfile/index"))
);

// ==============================|| AUTH ROUTING ||============================== //

const ConnectionRoute = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/profile/:id/:value",
      element: <AlumniProfile />,
    },
  ],
};

export default ConnectionRoute;
